import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { FhqHelpContactsState } from '@reducers/fhq-help-contacts';

export const getFhqHelpContacts = (state: RootState): FhqHelpContactsState => state.fhqHelpContacts;
export const getFhqHelpContactsData = createSelector(getFhqHelpContacts, (helpContacts) => helpContacts?.data);
export const isFhqHelpContactsLoading = createSelector(getFhqHelpContacts, (helpContacts) => helpContacts?.loading);
export const getFhqHelpContactsError = createSelector(
  getFhqHelpContacts, (helpContacts) => helpContacts?.error as Error,
);
